/* src/app.js */
/* eslint-disable */

// Styles
import "./assets/styles/main-ltr.scss";


import 'bootstrap';

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	require('./assets/scripts/smooth-scroll.js');
} else {
	require('./assets/scripts/SmoothScroll');

}



// $(document).ready(() => {
require('./assets/scripts/slick-animation.min');

require('./assets/scripts/sliders');


require('./assets/scripts/auto-hide-header');


require('./assets/scripts/e-motion-validate');
require('./assets/scripts/custom');

require('./assets/scripts/google_map_stores');

// });

if (document.querySelector("#mySpriteSpin") || (document.querySelector(".rotate-in-hover"))) {
	require('./assets/scripts/threeD');
}
require('./assets/scripts/boxImages');

require('./assets/scripts/inputfilevalue');


if (document.querySelector(".careers")) {
	require('./assets/scripts/careers');
}

require('./assets/scripts/reservation');

require('./assets/scripts/bootstrap-datepicker.min');
require('./assets/scripts/datepicker-custom');

require('./assets/scripts/searchFullScreen');


if(document.querySelector(".parentSelect")) {

	require('./assets/scripts/twoSelect');
}


require('./assets/scripts/photoswipe-lightbox.esm');
require('./assets/scripts/photoswipe.esm');
require('./assets/scripts/photoswipecustom');

require('./assets/scripts/requestTime');